import React from 'react';
import _ from 'lodash';

import Box from '@mui/material/Box';

import { FiberManualRecordIcon } from '../customStyles/images';
import theme from '../../theme';

const TreeMapLabel = ({ chartData, colors, label }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        color: theme.palette.grey.w500,
        fontSize: 14,
        fontWeight: 400,
        flexWrap: 'wrap',
        flexDirection: 'row',
        minHeight: '5vh',
        maxHeight: '5vh'
      }}
    >
      {
        chartData && colors &&
        chartData.map((el, index) => {
          return (
            <Box
              key={`${el}-${index}`}
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <FiberManualRecordIcon style={{ color: colors[el.name] }} /><span key={`${el}-${index}`}>{el[label]}</span>　　
            </Box>
          )
        })
      }
    </Box>
  )
}

export default TreeMapLabel;